export { default as edit } from "./Edit";
export { default as list } from "./List";
export const name = "media-center/admin/images";
export const options = {
  label: "Gallery/Images",
};
